import React from 'react'
import Select from 'react-select';

export default function MySelect({options, name, value,frwdRef, customOnChange,onChange,height,disabled, ...props}) {
  const customStyles = {
    container: (base,state) =>({
      ...base,
      width:"100%",
      fontSize: '13px',
      fontFamily: "inherit",
    }),
    control: (base, state) => ({
      ...base,
      width: '100%',
      minHeight: '45px',   // ensures a nice base height
      height: 'auto',      // allow it to expand
      flexWrap: 'wrap',
      borderRadius: '5px',
      border: state.isFocused ? '1px solid var(--prolex-blue);' : '1.5px solid lightgrey',
      outline: 'none',
      transition: 'all 0.3s cubic-bezier(0.19, 1, 0.22, 1)',
      color: 'black',
      fontSize: '13px',
      backgroundColor: 'white',
      fontFamily: "inherit",
      ':hover': {
        border: '1px solid var(--prolex-blue);',
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused || state.isSelected ? 'lightgrey' : 'white',
      color: 'black',
      padding: '8px 12px',
      fontSize: '13px',
      fontFamily: "inherit",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 10 ,
      fontSize: '13px',
      fontFamily: "inherit",
  }),
  menuPortal: base => ({ 
  ...base, zIndex: 9999,
  fontSize: "13px",
  fontFamily: "inherit", 
}),
  placeholder:(base)=>({
    ...base,
    fontSize: '13px',
    fontFamily: "inherit",
  })
  };
  const handleChange = (option) => {
    if (typeof onChange === 'function') {
      if (props.isMulti) {
        onChange(option || []);
      } else {
        onChange(option ? option.value : null);
      }
    }
  
    if (typeof customOnChange === 'function') {
      customOnChange(option);
    }
  };
  
  return (
    <Select
      ref = {frwdRef}
      value={value}
      onChange={handleChange}
      options={options}
      styles={customStyles}
      isDisabled={disabled}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      {...props}
    />
  );
}
